export default __webpack_public_path__ + "static/media/photo--sm--misc-11.f3ee2665.jpg";